import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { tutorSlotMovesService } from "@data/services/tutorSlotMovesService"

/**
 * Les choix « garder son tuteur » en attente de l'élève connecté (`GET api/v1/tutor-slot-moves`),
 * lus par la ligne « À faire » de l'accueil parent. Une ligne par choix : ses cours libérés sont
 * dans `move_ids`, et son `id` est le premier d'entre eux.
 */
const initialState = {
    moves: [],
}

/** Le choix porte-t-il ce cours libéré ? Une ligne d'avant les groupes n'a que son `id`. */
function holdsMove(move, id) {
    if (String(move?.id) === String(id)) return true
    return Array.isArray(move?.move_ids) && move.move_ids.some((moveId) => String(moveId) === String(id))
}

/** Le choix tranché sort de la liste tout de suite : la ligne « À faire » n'attend pas la relecture. */
function withoutMove(state, id) {
    if (id == null) return state
    return {
        ...state,
        moves: state.moves.filter((move) => !holdsMove(move, id)),
    }
}

export function tutorSlotMoves(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authConstants.SWITCH_ACCOUNT:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        case tutorSlotMovesService.getTutorSlotMoves.name +
            apiConstants._SUCCESS:
            // Partie sous le jeton de l'enfant d'avant une bascule : ce sont SES choix, pas ceux-ci.
            if (action.fromPreviousSession) return state
            // Presque aucune famille n'a de choix : une liste vide relue ne doit rien recalculer.
            if (state.moves.length === 0 && !(Array.isArray(action.data) && action.data.length > 0)) return state
            return {
                ...state,
                moves: Array.isArray(action.data) ? action.data : [],
            }

        case tutorSlotMovesService.bookTutorSlotMove.name +
            apiConstants._SUCCESS:
        case tutorSlotMovesService.keepTutorSlotMove.name +
            apiConstants._SUCCESS:
        case tutorSlotMovesService.splitTutorSlotMove.name +
            apiConstants._SUCCESS:
            return withoutMove(state, action.routeParams?.id)

        // Le serveur dit le choix fermé (échéance passée) : il sort aussi, la ligne n'offre plus rien.
        case tutorSlotMovesService.getTutorSlotMoveOptions.name +
            apiConstants._FAILURE:
        case tutorSlotMovesService.bookTutorSlotMove.name +
            apiConstants._FAILURE:
        case tutorSlotMovesService.keepTutorSlotMove.name +
            apiConstants._FAILURE:
        case tutorSlotMovesService.splitTutorSlotMove.name +
            apiConstants._FAILURE:
            if (action.error?.code !== "closed") return state
            return withoutMove(state, action.routeParams?.id ?? action.urlParams?.id)

        default:
            return state
    }
}

export default tutorSlotMoves
